export default __webpack_public_path__ + "static/media/o2DeliveryIcon.a2862f65.svg";